import gql from 'graphql-tag';
import { PRODUCT_ARRANGEMENT_FRAGMENT, PRODUCT_ARRANGEMENT_PRODUCT_FRAGMENT } from './productArrangement';

export const MICROSTORE_LOCATION_TEMPLATE_FRAGMENT = gql`
    fragment MicrostoreLocationTemplateFragment on MicrostoreLocationTemplate {
        _id
        productArrangement {
            ...ProductArrangementFragment
        }
        alternativeProductArrangementIds
        productId
        product {
            ...ProductArrangementProductFragment
        }
        stockMax
        reassortmentType
        trayMaxCapacity
    }
    ${PRODUCT_ARRANGEMENT_FRAGMENT}
    ${PRODUCT_ARRANGEMENT_PRODUCT_FRAGMENT}
`;
